import {AlertTriangle} from 'lucide-react'

function DisclaimerNote() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-500/20 bg-amber-500/5 p-4">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
      <p className="text-xs leading-relaxed text-amber-200/80">
        Results are estimates for informational purposes only and do not constitute financial, investment, tax, or legal advice.
        Actual values may vary based on market conditions, fees, and individual circumstances. See our
        {' '}
        <a href="/disclaimer" className="underline hover:text-amber-100">Financial Disclaimer</a>
        {' '}
        for details.
      </p>
    </div>
  )
}

export default DisclaimerNote
